/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsServerDataParser} from "../FruitsServerDataParser";
import {IFruitsParsedServerData} from "./FruitsParsedServerData";
import {IFruitsInitData} from "./IFruitsServerData";

export class FruitsParsedInitData extends ParsedInitData implements IFruitsParsedServerData {

    private _overlayStickySymbols:boolean[];
    private _stickySymbol:string;
    private _bonusSpinsLeft:number;
    private _bonusSpinsPlayed:number;
    private _isBonusTriggeredThisSpin:boolean;
    private _bonusGameQueued:boolean;
    private _bonusOverlayPositionsBefore:boolean[][];
    private _currentBonusPaytable:number[];
    private _collectedScattersBefore:number;
    private _collectedScattersAfter:number;
    private _isStickyRespinTriggeredThisSpin:boolean;
    private _numberOfBonusSpinsPlayed:number;
    private _bonusInitReels:string[][];
    private _reelsEnteringBonus:string[][];

    public get overlayStickySymbols():boolean[] {
        return this._overlayStickySymbols;
    }

    public get stickySymbol():string {
        return this._stickySymbol;
    }

    public get bonusSpinsLeft():number {
        return this._bonusSpinsLeft;
    }

    public get bonusSpinsPlayed():number {
        return this._bonusSpinsPlayed;
    }

    public get numberOfBonusSpinsPlayed():number {
        return this._numberOfBonusSpinsPlayed;
    }


    public get isBonusTriggeredThisSpin():boolean {
        return this._isBonusTriggeredThisSpin;
    }

    public get bonusGameQueued():boolean {
        return this._bonusGameQueued;
    }

    public get isStickyRespinTriggeredThisSpin():boolean {
        return this._isStickyRespinTriggeredThisSpin;
    }

    public get bonusOverlayPositionsBefore():boolean[][] {
        return this._bonusOverlayPositionsBefore;
    }

    public get currentBonusPaytable():number[] {
        return this._currentBonusPaytable;
    }

    public get collectedScattersBefore():number {
        return this._collectedScattersBefore;
    }

    public get collectedScattersAfter():number {
        return this._collectedScattersAfter;
    }

    public get bonusInitReels():string[][] {
        return this._bonusInitReels;
    }

    public get reelsEnteringBonus():string[][] {
        return this._reelsEnteringBonus;
    }

    protected isFeatureTotalWin():boolean {
        return this.mode === FruitsGameMode.STICKY_RESPIN || this.mode === FruitsGameMode.BONUS_GAME;
    }

    protected isNextFeatureTotalWin():boolean {
        return (this.mode !== FruitsGameMode.STICKY_RESPIN && this.nextMode === FruitsGameMode.STICKY_RESPIN) ||
            (this.mode !== FruitsGameMode.BONUS_GAME && this.nextMode === FruitsGameMode.BONUS_GAME);
    }

    constructor(rawData:IFruitsInitData, dataParser:FruitsServerDataParser) {
        super(rawData, dataParser);
        this._overlayStickySymbols = dataParser.parseOverlayStickySymbols(rawData.overlayStickySymbols);
        this._stickySymbol = dataParser.parseStickySymbol(rawData);
        this._bonusSpinsLeft = dataParser.parseBonusSpinsLeft(rawData);
        this._bonusSpinsPlayed = dataParser.parseBonusSpinsPlayed(rawData);
        this._numberOfBonusSpinsPlayed = dataParser.parseNumberOfBonusSpinsPlayed(rawData);
        this._isBonusTriggeredThisSpin = dataParser.parseIsBonusTriggeredThisSpin(rawData);
        this._isStickyRespinTriggeredThisSpin = dataParser.parseIsBonusTriggeredThisSpin(rawData);
        this._bonusOverlayPositionsBefore = dataParser.parseBonusOverlayPositionsBefore(rawData);
        this._currentBonusPaytable = dataParser.parseCurrentBonusPaytable(rawData);
        this._collectedScattersBefore = dataParser.parseCollectedScatterBefore(rawData);
        this._collectedScattersAfter = dataParser.parseCollectedScatterAfter(rawData);
        this._bonusInitReels = dataParser.parseBonusInitReels(rawData);
        this._reelsEnteringBonus = dataParser.parseReelsEnteringBonus(rawData);
        this._bonusGameQueued = dataParser.parseBonusGameQueued(rawData);
    }
}